import { NavLink } from "react-router-dom";
import type { ReactNode } from "react";

import { useAdminLogout, useAdminMe } from "@/hooks/useAdminAuth";

function navClass({ isActive }: { isActive: boolean }) {
  return [
    "rounded-lg px-3 py-1.5 text-sm font-medium transition-colors",
    isActive
      ? "bg-emerald-100 text-emerald-900"
      : "text-slate-600 hover:bg-slate-100 hover:text-slate-900",
  ].join(" ");
}

export default function AdminLayout({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  const admin = useAdminMe();
  const logout = useAdminLogout();

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-4 px-4 py-4">
          <div>
            <h1 className="text-xl font-semibold">{title}</h1>
            <p className="text-sm text-slate-600">
              Sesión: {admin.data?.username ?? "…"}
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <nav className="flex flex-wrap gap-1" aria-label="Admin">
              <NavLink to="/admin" end className={navClass}>
                Fuentes
              </NavLink>
              <NavLink to="/admin/newsletter" className={navClass}>
                Newsletter
              </NavLink>
            </nav>
            <button
              type="button"
              onClick={() => logout.mutate()}
              className="rounded-lg border border-slate-300 px-3 py-1.5 text-sm hover:bg-slate-50"
            >
              Cerrar sesión
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-8">{children}</main>
    </div>
  );
}
